// extracted by mini-css-extract-plugin
export default {"form":"checkout_form__FjIGc","control":"checkout_control__sqyPP","invalid":"checkout_invalid__8VT33","actions":"checkout_actions__vTqRS"};